import * as React from "react";
import { forwardRef } from "react";
const SvgClose = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" ref={ref} {...props}><path fill="#32325D" d="M12.667 4.273L11.727 3.333 8 7.06 4.273 3.333 3.333 4.273 7.06 8 3.333 11.727 4.273 12.667 8 8.94 11.727 12.667 12.667 11.727 8.94 8z" /></svg>;
const ForwardRef = forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
import __svgUrl from "/home/jenkins/agent/workspace/k_Connect_service_dev_qa-release/src/images/close.svg?url";
export default __svgUrl;
